import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthService} from '../services/auth/auth.service';
import {Observable} from 'rxjs';
import {Globals} from '../global/globals';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /* eslint-disable @typescript-eslint/no-explicit-any */

  urisWithoutAuthentication = [
    ['POST',  this.globals.backendUri + '/authentication'],
    ['GET',   this.globals.backendUri + '/vocabulary/categories/roots'],
    ['GET',   this.globals.backendUri + '/vocabulary/entries'],
    ['PUT',   this.globals.backendUri + '/users/resetPassword'],
    ['POST',  this.globals.backendUri + '/users/resetPassword'],
    ['POST',  this.globals.backendUri + '/users/registration'],
    ['GET',   this.globals.backendUri + '/text/patterns'],
    ['GET',   this.globals.backendUri + '/text/types'],
    ['GET',   this.globals.backendUri + '/grammar/systemic/categories/roots'],
    ['GET',   this.globals.backendUri + '/grammar/systemic/entries'],
    ['GET',   this.globals.backendUri + '/grammar/systemic/categories/*/explanation'],
    ['GET',   this.globals.backendUri + '/grammar/functional/categories/roots'],
    ['GET',   this.globals.backendUri + '/grammar/functional/entries'],
  ];


  constructor(private authService: AuthService, private globals: Globals) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.noAuthNeeded(req.method, req.url)) {
      return next.handle(req);
    }

    if (!this.authService.getToken()) {
      return next.handle(req);
    }

    const authReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + this.authService.getToken())
    });

    return next.handle(authReq);
  }

  noAuthNeeded(method: string, url: string): boolean {
    this.urisWithoutAuthentication.forEach(s => {
      const regex = new RegExp(s[1]);
      if (method === s[0] && regex.test(url)) {
        return true;
      }
    });
    return false;
  }
}
